module.exports = "a {\n    cursor: pointer;\n}\n\n.help-block {\n    font-size: 12px;\n    color: #f44336 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.css
// module id = ./src/assets/app.css
// module chunks = main